export var environment = function environment() {
  if (window.location.hostname.match(/\.staging\./g)) {
    return 'staging';
  }
  if (window.location.hostname.match(/\.edev\./g)) {
    return 'development';
  }
  if (window.location.hostname.match(/\.dev\./g)) {
    return 'development';
  }
  if (window.location.hostname.match(/\.test\./g)) {
    return 'test';
  }
  if (window.location.hostname.match(/\.docker|\.localhost|\.sqr\./g)) {
    return 'docker';
  }
  return process.env.NODE_ENV;
};
export default environment;